export default __webpack_public_path__ + "static/media/top10.e35d952d.jpg";